import { getSharing } from '../selectors/content';
import { fetchSharing } from '../actions/content';

export function sharingResource(options, id) {
    const { content } = options.props;
    return {
        id: `sharing-${id}`,
        load() {
            return options.dispatch(fetchSharing(content));
        },
        find() {
            return getSharing(options.rootState, content);
        },
    };
}



// WEBPACK FOOTER //
// ./src/resources/sharing.js